"use client";

import { useState } from "react";
import DecisionThreadsScreen from "@/components/review/DecisionThreadsScreen";
import { useOverlayManager } from "@/components/overlays/OverlayManager";

interface Props {
  onNavigate?: (tab: string) => void;
}

export default function DecisionScreen({ onNavigate: _onNavigate }: Props) {
  const { openNewDecision } = useOverlayManager();
  const [refreshNonce, setRefreshNonce] = useState(0);
  const [refreshNotice, setRefreshNotice] = useState<string | null>(null);

  return (
    <DecisionThreadsScreen
      onOpenNewDecision={() =>
        openNewDecision({
          onCreated: (notice) => {
            setRefreshNotice(notice);
            setRefreshNonce((current) => current + 1);
          },
        })
      }
      refreshNonce={refreshNonce}
      refreshNotice={refreshNotice}
    />
  );
}
